<template lang="pug">
  .component-transaction-list.row.column
    transaction-list-form(@filterTransactions="setSearch")
    base-list(:component="component", :dataLoader="dataLoader", :search="search")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import TransactionListForm from "../../components/structure/ui/filters/TransactionListForm";
  import BaseList from "./BaseList";

  export default {
    name: "TransactionList",
    components: {
      BaseList,
      TransactionListForm,
    },
    data() {
      return {
        component: require('components/backoffice/Transaction'),
        headers: ['', 'Date', 'Client', 'Payment method', 'Invoice', 'Amount', 'Status', ''],
        search: null
      }
    },
    methods: {
      setSearch(search) {
        this.search = search
      },
      dataLoader(callback, page, resultsPerPage, search) {
        KeplerBackofficeSdk.transactions.list(page, resultsPerPage, search).all((data) => {
          callback(data)
        })
      },
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// TransactionList.vue?2ab8e580